module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0091.jpg?v=6c9748da";